import { omit } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { CardSelect } from '../';
import timezones from '../../../lib/utils/timezones';

const CardTZSelect = ({ value, ...rest }) => {
  const options = timezones.map(t => ({ value: t.name, text: t.text }));
  if (options.filter(o => o.value === value).length === 0) {
    options.push({ value, text: value });
  }
  return (
    <CardSelect
      options={options}
      value={value}
      fluid
      search
      {...omit(rest, 'options')}
    />
  );
};

CardTZSelect.propTypes = {
  value: PropTypes.string
};


export default CardTZSelect;



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/CardTZSelect.js